module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_7_3.80845d3c.jpeg";